import { apiClient } from './client'
import type { User, UpdateUserDto } from '@flight-journal/shared'

interface UserListItem {
  id: string
  email: string
  canac_id: string | null
  first_name: string
  last_name: string
  full_name: string
  role: string
  organization_id: string | null
}

export const usersApi = {
  async list(): Promise<UserListItem[]> {
    const response = await apiClient.get('/api/v1/users')
    return response.data
  },

  async getCurrent(): Promise<User> {
    const response = await apiClient.get('/api/v1/users/me')
    return response.data
  },

  async update(userId: string, data: UpdateUserDto): Promise<User> {
    const response = await apiClient.patch(`/api/v1/users/${userId}`, { user: data })
    return response.data
  }
}
